import { EventBusKey } from "@vueuse/core";

export const confirmationEmailDialogKey: EventBusKey<ConfirmationEmail> = Symbol()

export interface ConfirmationEmail {
    // eslint-disable-next-line
    callback: (email: string, pricedConfirmation: boolean) => Promise<unknown>;
}